function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 8.875,
  y: 5.4375,
  width: 13.8125,
  height: 14.625,
  rx: 2,
  stroke: "#22A244",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.82008 5.26588L14.0076 4.07497C14.7616 3.96529 15.4375 4.54999 15.4375 5.31196V20.188C15.4375 20.95 14.7616 21.5347 14.0076 21.425L5.82007 20.2341C5.20568 20.1448 4.75 19.618 4.75 18.9971V6.50286C4.75 5.88201 5.20568 5.35525 5.82008 5.26588Z",
  fill: "white",
  stroke: "#22A244",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.36187 12.685L8.3756 10.9114C8.3182 10.8093 8.26602 10.7071 8.21905 10.605C8.17991 10.5214 8.14338 10.4332 8.10947 10.3404C8.07816 10.2475 8.0625 10.1686 8.0625 10.1036C8.0625 10.02 8.08207 9.93488 8.12121 9.84821C8.16295 9.76155 8.23471 9.68262 8.33646 9.61143C8.45388 9.53714 8.56085 9.5 8.65739 9.5C8.73045 9.5 8.79699 9.52012 8.857 9.56036C8.91962 9.5975 8.97571 9.64857 9.02529 9.71357C9.07747 9.77548 9.12574 9.84667 9.1701 9.92714C9.21445 10.0076 9.25751 10.0881 9.29925 10.1686L10.0272 11.5893H10.1446L10.8726 10.1686C10.9143 10.0881 10.9574 10.0076 11.0017 9.92714C11.0461 9.84667 11.0931 9.77548 11.1426 9.71357C11.1948 9.64857 11.2509 9.5975 11.3109 9.56036C11.3709 9.52012 11.4388 9.5 11.5145 9.5C11.5614 9.5 11.611 9.51083 11.6632 9.5325C11.718 9.55417 11.7754 9.58357 11.8354 9.62071C11.945 9.6919 12.0206 9.76929 12.0624 9.85286C12.1041 9.93333 12.125 10.0138 12.125 10.0943C12.125 10.1624 12.108 10.2429 12.0741 10.3357C12.0402 10.4286 12.0024 10.5183 11.9606 10.605C11.9137 10.7071 11.8589 10.8093 11.7962 10.9114L10.8178 12.685V12.7686L11.9058 14.8021C11.9606 14.9043 12.0076 15.0064 12.0467 15.1086C12.0885 15.2076 12.1093 15.3067 12.1093 15.4057C12.1093 15.4893 12.0898 15.5729 12.0506 15.6564C12.0141 15.7369 11.945 15.8143 11.8432 15.8886C11.7258 15.9629 11.6188 16 11.5223 16C11.4544 16 11.3931 15.9845 11.3383 15.9536C11.2835 15.9195 11.2327 15.8762 11.1857 15.8236C11.1387 15.771 11.0944 15.7106 11.0526 15.6425C11.0135 15.5744 10.9743 15.5048 10.9352 15.4336L10.1446 13.9107H10.0272L9.23663 15.4336C9.1975 15.5048 9.15705 15.5744 9.11531 15.6425C9.07617 15.7106 9.03312 15.771 8.98615 15.8236C8.9418 15.8762 8.89222 15.9195 8.83743 15.9536C8.78263 15.9845 8.72262 16 8.65739 16C8.55825 16 8.45388 15.9629 8.34429 15.8886C8.23732 15.8143 8.16295 15.7369 8.12121 15.6564C8.08207 15.5729 8.0625 15.4893 8.0625 15.4057C8.0625 15.3067 8.08207 15.2076 8.12121 15.1086C8.16295 15.0064 8.21122 14.9043 8.26602 14.8021L9.36187 12.7686V12.685Z",
  fill: "#22A244"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6055 10.75H22.6055",
  stroke: "#22A244",
  strokeWidth: 1.5
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M18.625 5.4375L18.625 20.2475",
  stroke: "#22A244",
  strokeWidth: 1.5
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6055 14.75H22.6055",
  stroke: "#22A244",
  strokeWidth: 1.5
});

var SvgExcel = function SvgExcel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExcel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/excel.9860c5fa.svg";
export { ForwardRef as ReactComponent };